import { useDispatch, useSelector } from 'react-redux';

import { setSort } from 'Core/actions/request.js';
import uiConfig from 'Models/uiConfig/uiConfig';
import t from 'Utils/translate';

export default function SortSelect({ className }) {
  const dispatch = useDispatch();
  const sort = useSelector((state) => state.search.request.sort);

  const onChange = (e) => dispatch(setSort(e.target.value));

  const props = {
    className,
    onChange,
    value: sort,
  };

  return (
    <select {...props} aria-label="Sort by">
      {uiConfig.sortFields.map((sortField) => (
        <option value={sortField} key={sortField}>
          {t(`sort_option_${sortField.replace(':', '_')}`)}
        </option>
      ))}
    </select>
  );
}
